import axios from '../../config/http.js'
import store from '@/store/index.js'; //需要引入store
import moment from 'moment';
import router from '@/router'
import {
	Notification
} from 'element-ui';

let common = {
	handleGoodsNum() {
		//查询库存
		axios({
			method: 'POST',
			url: '/mall/goods/not/enough'
		}).then(function(res) {
			store.commit('setNotEnough', res.data.data);
		});
	},
	getUUID() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (Math.random() * 16) | 0,
				v = c == 'x' ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	},
	findIndexById(items, id) {
		var index = -1;
		items.forEach((item, i) => {
			if (item.id == id) {
				index = i;
				return false;
			}
		});
		return index;
	},
	post(url, cb) {
		axios({
			method: 'POST',
			url: url
		}).then(function(res) {
			if (res.data.errorCode == '0000') {
				if (cb != null) {
					cb(res.data);
				}
			}
		});
	},
	postBody(url, data, cb) {
		axios({
			method: 'POST',
			url: url,
			data
		}).then(function(res) {
			if (res.data.errorCode == '0000') {
				if (cb != null) {
					cb(res.data);
				}
			}
		});
	},
	isLogin() {
		var token = sessionStorage.getItem('token');
		if (token) {
			return true;
		} else {
			return false;
		}
	},
	signOut(context) {
		sessionStorage.removeItem('menuId');
		sessionStorage.removeItem('menuName');
		sessionStorage.removeItem('token');
		sessionStorage.removeItem('breadcrumb');
		sessionStorage.removeItem('displayButtonList');
		var code = sessionStorage.getItem('institutionCode');
		sessionStorage.clear();
		this.routerPush(context,'/login')
	},
	initSessionStorage(data) {
		sessionStorage.setItem('menuId', data.id);
		sessionStorage.setItem('menuName', data.label);
		sessionStorage.setItem('displayButtonList', data.permTypes);
		store.commit('breadcrumb', data.label, data.perUrl);
		sessionStorage.setItem('perUrl', data.perUrl);
	},
	formatDate(timeStamp) {
		return moment(Number.parseInt(timeStamp)).format('YYYY-MM-DD HH:mm:ss');
	},
	showNotify(msg) {
		if (router.currentRoute.path != '/user/cmmessage') {
			Notification({
				message: msg,
				position: 'bottom-right',
				onClick: function() {
					if (router.currentRoute.path != '/user/cmmessage') {
						router.push('/user/cmmessage');
					}
				}
			});
		}
	},
	getBreadcrumbList(context,menu) {
		var list = []
		while (menu) {
			list.splice(0, 0, {
				url: this.getToUrl(context,menu.perUrl),
				title: menu.label
			});
			menu = menu.parent
		}
		return list
	},
	routerPush(context, url, query) {
		var _url = this.getToUrl(context,url);
		if (query) {
			context.$router.push({
				path: _url,
				query: query
			});
		} else {
			context.$router.push(_url);
		}
	},
	getToUrl(context, url) {
		if (url) {
			var _url = `/${context.$route.params.code}/${url}`
			if (url.startsWith('/')) {
				_url = `/${context.$route.params.code}${url}`
			}
			return _url
		}

	},
	routerReplace(context, url, query) {
		var _url = this.getToUrl(context,url);
		if (query) {
			context.$router.replace({
				path: _url,
				query: query
			});
		} else {
			context.$router.replace(_url);
		}
	}

}


export default common;


// WEBPACK FOOTER //
// ./src/common/common.js